import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { useLocation } from "react-router-dom";
import { GlobalContainer } from "../../assets/styles/mainPageStyles";
import { PlanetBlockHeader, PlanetBlockGradientText } from "../../assets/styles/pageNotFound";
import CanvasScene from "../../components/globe/CanvasScene";
import Header from "../../components/header/Header";
var underDevRoutes = [
    "/learn",
    "/audit-report",
    "/media-kit",
    "/privacy-policy",
    "/terms",
    "/cookie-policy",
    "/contact-us",
    "/home",
];
var NotFoundPage = function (_a) {
    var currentLocale = _a.currentLocale, onLocaleChange = _a.onLocaleChange;
    var pathname = useLocation().pathname;
    var isUnderDevelopment = underDevRoutes.includes(pathname);
    return (_jsxs(GlobalContainer, { children: [_jsx(Header, { currentLocale: currentLocale, onLocaleChange: onLocaleChange }), _jsxs("div", { style: { marginTop: "50px", textAlign: "center" }, children: [isUnderDevelopment ? (_jsxs(_Fragment, { children: [_jsx(PlanetBlockHeader, { children: "Under" }), _jsx(PlanetBlockGradientText, { children: "Development" })] })) : (_jsxs(_Fragment, { children: [_jsx(PlanetBlockHeader, { children: "NOT FOUND" }), _jsx(PlanetBlockGradientText, { children: "404" })] })), _jsx("div", { style: {
                            margin: "50px auto",
                            width: "347px",
                            height: "347px",
                        }, children: _jsx(CanvasScene, { x: 0, y: 0, z: 0, color: 0x411c1f }) })] })] }));
};
export default NotFoundPage;
